export default "__VITE_ASSET__BTz4bJ0E__"